import { PAYMENT_OPTIONS } from "pagesV2/pro/Bookings/constants"

// The options whose fees are baked into the price at booking time live in
// utils/bookingCalculations as hasCreationBakedFees — shared with the booking form, so the rule is
// defined once.

// Payment options where the card processing fee was already settled up front, so the remaining
// balance carries none.
export const CARD_FEE_SETTLED_OPTIONS = [PAYMENT_OPTIONS.deposit_later, PAYMENT_OPTIONS.deposit_link]

// Full-payment options that collect the guest platform fee at collection time. Cash on the day is
// included by client decision (2026-09-10): a guest who arrives without cash and pays by card or
// link pays the fees, the same as any card booking. Collecting actual cash stays fee-free because
// the fee gates require a card or link tab.
export const PLATFORM_FEE_ON_COLLECTION_OPTIONS = [
  PAYMENT_OPTIONS.full_now,
  PAYMENT_OPTIONS.full_link,
  PAYMENT_OPTIONS.full_cash
]

// Titles the backend gives the two payment-method fees inside outstanding_breakdown.items, matched
// by title because that is how the payload identifies them (the same match the store makes on
// custom_fees).
export const CARD_FEE_LABEL = "Card Processing Fee"
export const METHOD_FEE_LABELS = ["Platform Fee", CARD_FEE_LABEL]

// Options booked to be paid in cash on the day. These are the only ones that quote the guest NO DS
// fee at all, so a cash collection on them carries neither fee. Every other option quotes a
// fee-inclusive price the guest agreed to, so its platform fee still stands when they pay cash —
// only the card processing fee comes off, because no card was charged.
export const NO_QUOTED_FEE_OPTIONS = [PAYMENT_OPTIONS.full_cash]

export const PAYMENT_TABS = {
  CARD: "card",
  LINK: "link",
  CASH: "cash",
  OTHERS: "others"
}

export const LINK_PROVIDERS = {
  STRIPE: "stripe",
  PAYPAL: "paypal"
}

export const OTHERS_TYPES = [
  { value: "check", label: "Check" },
  { value: "e_transfer", label: "E-Transfer" },
  { value: "pay_pal", label: "Paypal" },
  { value: "zelle", label: "Zelle" },
  { value: "venmo", label: "Venmo" },
  { value: "other", label: "Other" }
]

export const paymentProvider = {
  card: "stripe",
  link: "stripe",
  paypalLink: "paypal"
}

// PayPal's processing rate, used when a payment link is sent via PayPal rather than Stripe. Stripe's
// own rate comes from the guide's fee settings / the selected card.
export const PAYPAL_CARD_FEE = { rate: 0.0349, fixed: 0.49 }
